import { render, staticRenderFns } from "./Trc20.vue?vue&type=template&id=7203a79a&scoped=true"
import script from "./Trc20.vue?vue&type=script&lang=js"
export * from "./Trc20.vue?vue&type=script&lang=js"
import style0 from "./Trc20.vue?vue&type=style&index=0&id=7203a79a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203a79a",
  null
  
)

export default component.exports